import { useState } from "react";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";
const FAQ_DATA = [
  { q:"How do I place an order?",                   a:"Browse our menu, add items to cart, and checkout. You need an account to track orders — sign up free in under 30 seconds." },
  { q:"What payment methods do you accept?",         a:"Visa, Mastercard, Rupay, all debit cards, UPI (Google Pay, PhonePe, Paytm), Net Banking, and Cash on Delivery." },
  { q:"Can I modify my order after placing it?",     a:"You can modify or cancel within 3 minutes of placing your order via the app or by calling us. After that, our kitchen starts preparation." },
  { q:"What if my food quality is unsatisfactory?",  a:"Contact us within 30 minutes of delivery with your order ID and photos. We'll investigate and either replace the item or issue a full refund." },
  { q:"Do you cater for allergen requirements?",     a:"Our kitchens handle nuts, dairy, gluten and eggs. For severe allergies, call us directly before ordering so our chefs can take precautions." },
  { q:"Do you have a loyalty program?",              a:"Yes! Earn 1 GamapaPoint per $1 spent. Redeem 100 points for $5 off. Check your Points balance in your Profile page." },
  { q:"How is the food packaged?",                   a:"All food is packed in biodegradable, FSSAI-certified containers with tamper-evident seals. Hot items have insulated packaging to stay hot." },
  { q:"Can I schedule a delivery in advance?",       a:"Yes! During checkout, choose a time slot up to 3 days in advance. Perfect for meal planning." },
];

export const Faq = () => {
  const [open, setOpen] = useState(null);
   const navigate = useNavigate();

  return (
    <div>
      <section className="bg-gradient-to-br from-[#f97316] to-red-600 text-white py-20 px-4 text-center">
        <h1 className="font-serif text-5xl mb-3">Frequently Asked <span className="text-yellow-300">Questions</span></h1>
        <p className="text-orange-100">Everything you need to know about GamapaFoods</p>
      </section>
      <div className="max-w-3xl mx-auto px-4 py-14 space-y-2">
        {FAQ_DATA.map((faq,i) => (
          <div key={i} className="bg-white rounded-2xl border border-gray-100 overflow-hidden shadow-sm">
            <button onClick={() => setOpen(open===i?null:i)} className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-gray-50 transition-colors">
              <span className="font-semibold text-gray-900 text-sm">{faq.q}</span>
              <span className={`text-[#f97316] font-black text-xl transition-transform duration-300 flex-shrink-0 ml-3 ${open===i?"rotate-45":""}`}>+</span>
            </button>
            <div className={`overflow-hidden transition-all duration-300 ${open===i?"max-h-40":"max-h-0"}`}>
              <p className="px-5 pb-5 text-sm text-gray-500 leading-relaxed">{faq.a}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-orange-50 border-t border-orange-100 py-12 px-4 text-center">
        <h2 className="font-serif text-2xl text-gray-900 mb-2">Still need help?</h2>
        <p className="text-gray-400 mb-6">Our team is available 7 days a week, 7 AM to 11 PM</p>
        <div className="flex gap-4 justify-center">
          <button onClick={() => navigate("/contact")} className="bg-[#f97316] text-white font-bold px-6 py-3 rounded-xl btn-press hover:bg-orange-600">📞 Contact Us</button>
          { /* <button className="border border-gray-200 text-gray-600 font-semibold px-6 py-3 rounded-xl btn-press hover:border-orange-300">💬 Live Chat</button> */ }
        </div>
      </div>
        <Footer />
    </div>
  );
};
